module.exports = require('./build/layouts/Drawer');
